module.exports = global["$"] = require("-!./index.js?bootstrap");